import { CommonService } from './../../../services/common/common.service';
import { LoaderService } from './../../../services/infrastructure/loader.service';
import { Router } from '@angular/router';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { QuoteOrderService } from './../../../services/quote-order/quote-order.service';
import { trigger, state, style, transition, animate } from '@angular/animations';

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { Subscription } from 'rxjs';
import { MasterConstants } from '../../../common/constants/master-constants';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-quote-order-summary',
  templateUrl: './quote-order-summary.component.html',
  styleUrls: ['./quote-order-summary.component.scss'],

  animations: [
    trigger('smoothCollapse', [
      state('initial', style({
        height: '0',
        overflow: 'hidden',
        opacity: '0'
      })),
      state('final', style({
        overflow: 'hidden',
        opacity: '1'
      })),
      transition('initial=>final', animate('300ms')),
      transition('final=>initial', animate('300ms'))
    ]),
  ]
})
export class QuoteOrderSummaryComponent implements OnInit, OnDestroy {
  private subscription = new Array<Subscription>();

  data: any = {};
  showPDFIcon: boolean;
  itemsDataSource: any[];
  pdfDataObject: any;
  isRedirectedFromPlacedOrder = false;
  webOrderNumber = '';
  ind: number;
  quoteId: number;
  plAccess = false;

  constructor(private quoteOrderService: QuoteOrderService,
    private router: Router,
    private loaderService: LoaderService,
    private commonService: CommonService,
    private quoteService: QuoteOrderService) { }

  ngOnInit() {
    this.subscription.push(this.quoteService.quoteId.subscribe(x => {
      if (x && x > 0) {
        this.quoteId = x;
        this.subscription.push(this.quoteService.cppOrderId.subscribe(c => {
          let cppOrderId = 0;
          if (c && c > 0) {
            cppOrderId = +c;
          }
          this.getOrderSummaryData(this.quoteId, cppOrderId);
        }));
      }
    }));

    this.plAccess = this.commonService.checkUserRoleAccessTypeForMenu(null, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST);
  }

  getOrderSummaryData(orderId: number, cppOrderId: number) {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.quoteOrderService.getQuoteOrderSummary(orderId, cppOrderId).subscribe((result) => {
      this.pdfDataObject = result;
      // console.log(`pdfDataObject: ${this.pdfDataObject}`);
      this.data = result;
      this.itemsDataSource = result.cppOrders;

      this.itemsDataSource.forEach(data => {
        data.isCollapsed = true;
        if (data && data.soldToDetail) {
          data.soldToDetail.address2 = data.soldToDetail.address2.replace('<br>', '');
        }
      });

      if (result && result.cppOrders && result.cppOrders.length > 0 && result.cppOrders.filter(x => x.splitId == 1).length > 0) {
        this.showPDFIcon = false;
      } else {
        this.showPDFIcon = true;
      }
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  // get delivery date
  getDeliveryDate(item: any) {
    let data;
    if (item && item.productDetail && item.productDetail.length > 0) {
      data = item.productDetail[0].desiredDeliveryDate;
    }
    return data;
  }

  // Navigate  quote order page
  backToLandingPage() {
    this.router.navigate(['/cpp/landing-data']);
    this.commonService.currentTabIndex.next(2);
  }

  // Generate Pdf report
  generatePdf() {
    this.quoteService.generatePdf(this.pdfDataObject, this.plAccess);
  }

  // On page destroy
  ngOnDestroy() {
    this.quoteService.setQuoteId(0);
    this.quoteService.setCppOrderId(0);

    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
